import { casesActions } from "configs";
import {
  useCurrentCase,
  useParams,
  useDispatch,
  setErrorsFromResponse
} from "duck";
import {
  useUpdateTeethStateMutation,
  ToothStateEnum,
  Fragments
} from "requests";

export const useUpdateState = (onSuccess: () => void) => {
  const { id: caseId } = useParams();
  const dispatch = useDispatch();
  const shouldSync = useCurrentCase(data => data.shouldSync);
  const [updateState, { loading }] = useUpdateTeethStateMutation();

  return {
    loading,
    onUpdate(
      state: ToothStateEnum,
      selection: NonNullable<Fragments.StoredDentalChartings>
    ) {
      const realIds = selection.map(sel => sel._id).filter(Boolean) as number[];

      const allIds = selection
        .map(sel => sel._id || sel.fakeId)
        .filter(Boolean) as (number | string)[];

      if (shouldSync) {
        return updateState({
          variables: { input: { ids: realIds, toothState: state } }
        })
          .then(() => {
            dispatch(
              casesActions.updateTeethState({
                _id: caseId,
                data: { ids: allIds, state }
              })
            );
            onSuccess();
          })
          .catch(error => {
            setErrorsFromResponse(error);
          });
      }

      dispatch(
        casesActions.updateTeethState({
          _id: caseId,
          data: { ids: allIds, state }
        })
      );
      onSuccess();
    }
  };
};
